import type { LocalePack } from "./types";

const perks = [
  { title: "Nessuna carta di credito", text: "Bastano una carta di debito, contanti (EUR/RON) o bonifico bancario, senza deposito cauzionale." },
  { title: "Ritiro gratuito", text: "Ritiro gratuito presso il nostro ufficio a Bucarest o all'aeroporto Henri Coandă di Otopeni (OTP)." },
  { title: "Assicurazione completa inclusa", text: "RCA e CASCO, rovinieta (bollo autostradale) e chilometraggio illimitato già compresi nel prezzo." },
  { title: "Assistenza 24/7", text: "Consegna e riconsegna del veicolo a qualsiasi ora, con supporto rapido via WhatsApp al +40738792499." },
];

const airportPerksOtopeni = [
  { title: "Ritiro diretto in aeroporto", text: "Il nostro staff vi aspetta all'uscita arrivi di Otopeni con il veicolo già pronto, senza attese." },
  { title: "Nessun costo di ritiro", text: "Il ritiro all'aeroporto di Otopeni è completamente gratuito, senza sovrapprezzi nascosti." },
  { title: "Prezzi da 35 EUR/giorno", text: "Tariffe trasparenti su 28 auto disponibili, con rovinieta e chilometraggio illimitato inclusi." },
  { title: "Prenotazione via WhatsApp", text: "Bastano pochi messaggi al +40738792499 per confermare l'auto prima dell'atterraggio." },
];

const guidePerks = [
  { title: "Auto adatte al percorso", text: "Consigliamo il veicolo più adatto in base a strada, stagione e numero di passeggeri." },
  { title: "Rovinieta inclusa", text: "Il bollo autostradale obbligatorio è già compreso, pronto per ogni tratta del viaggio." },
  { title: "Assistenza in viaggio", text: "Supporto WhatsApp attivo 24/7 anche lontano da Bucarest, per qualsiasi imprevisto." },
  { title: "Consegna su richiesta", text: "Per itinerari lunghi organizziamo consegna e ritiro anche fuori Bucarest, previo preventivo." },
];

const rulesPerks = [
  { title: "Documenti sempre in regola", text: "Ogni auto viaggia con i documenti e la rovinieta necessari per circolare legalmente in Romania." },
  { title: "Nessuna sorpresa in fattura", text: "Multe e pedaggi vengono comunicati con trasparenza, senza costi nascosti a fine noleggio." },
  { title: "Consulenza pratica", text: "Vi spieghiamo le regole locali via WhatsApp prima della partenza, in italiano se necessario." },
  { title: "Copertura assicurativa totale", text: "RCA e CASCO incluse per guidare sereni su ogni tipo di strada rumena." },
];

export const it: LocalePack = {
  code: "it",
  htmlLang: "it",
  dir: "ltr",
  ui: {
    label: "Italiano",
    nav: {
      country: "Romania",
      airports: "Aeroporti",
      cities: "Città",
      guides: "Itinerari",
    },
    bookCta: "Prenota ora",
    fleetCta: "Vedi la flotta",
    whatsappCta: "Scrivici su WhatsApp",
    fleetTitle: "La nostra flotta",
    fleetSubtitle: "28 auto disponibili, da 35 EUR al giorno, con assicurazione completa inclusa",
    faqTitle: "Domande frequenti",
    mapTitle: "Dove ci trovi",
    relatedTitle: "Potrebbe interessarti anche",
    priceNote: "Prezzi a partire da 35 EUR/giorno, IVA inclusa, senza deposito cauzionale",
    breadcrumbHome: "Home",
  },
  pages: {
    country: {
      slug: "",
      title: "Noleggio auto Romania | carentals.ro da 35 EUR/giorno",
      description: "Noleggio auto in Romania senza deposito né carta di credito. Ritiro gratuito a Bucarest e Otopeni, assicurazione e rovinieta incluse.",
      eyebrow: "Noleggio auto in tutta la Romania",
      h1: "Noleggio auto Romania: libertà di viaggio senza pensieri",
      intro: "carentals.ro offre il noleggio auto in Romania più semplice e trasparente, con sede a Bucarest e ritiro gratuito anche all'aeroporto di Otopeni. Niente deposito cauzionale, niente carta di credito obbligatoria: solo un'auto pronta a partire.",
      perks,
      sections: [
        {
          h2: "Perché scegliere carentals.ro",
          body: [
            "Con 28 auto in flotta e prezzi a partire da 35 EUR al giorno, offriamo soluzioni adatte a ogni tipo di viaggio, dalla città alle strade di montagna.",
            "Ogni noleggio include assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, così potete pianificare il vostro itinerario senza costi a sorpresa.",
          ],
        },
        {
          h2: "Ritiro e consegna in tutta comodità",
          body: [
            "Il ritiro è gratuito presso il nostro ufficio in Bulevardul Regina Elisabeta 33 a Bucarest oppure direttamente all'aeroporto Henri Coandă di Otopeni.",
            "Per la consegna in un altro indirizzo di Bucarest applichiamo una tariffa fissa di 20 EUR, mentre per altre città la organizziamo su richiesta con preventivo via WhatsApp.",
          ],
        },
        {
          h2: "Pagamento semplice e flessibile",
          body: [
            "Accettiamo carta di debito, contanti in EUR o RON e bonifico bancario: nessuna carta di credito è obbligatoria per noleggiare.",
            "L'assistenza è disponibile 24 ore su 24 tramite WhatsApp al +40738792499, per consegne, riconsegne o qualsiasi domanda durante il viaggio.",
          ],
        },
      ],
      faqs: [
        { q: "Serve una carta di credito per noleggiare un'auto in Romania?", a: "No, non è obbligatoria. Accettiamo carta di debito, contanti in EUR o RON e bonifico bancario, senza alcun deposito cauzionale." },
        { q: "Cosa è incluso nel prezzo del noleggio?", a: "Il prezzo include assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, senza costi nascosti aggiuntivi." },
        { q: "Dove posso ritirare l'auto?", a: "Potete ritirarla gratuitamente presso il nostro ufficio a Bucarest o all'aeroporto di Otopeni; la consegna altrove è possibile su richiesta." },
        { q: "Come vi contatto per prenotare?", a: "Il modo più rapido è scriverci su WhatsApp al +40738792499: rispondiamo 24 ore su 24, tutti i giorni." },
      ],
      keywords: "noleggio auto Romania, autonoleggio Romania, affitto auto Romania",
    },
    "airport-otopeni": {
      slug: "noleggio-auto-bucarest-aeroporto-otopeni",
      title: "Noleggio auto Bucarest aeroporto Otopeni | carentals.ro",
      description: "Noleggio auto Otopeni con ritiro gratuito all'aeroporto Henri Coandă. Nessun deposito, assicurazione completa, da 35 EUR/giorno.",
      eyebrow: "Noleggio auto aeroporto di Bucarest",
      h1: "Noleggio auto Bucarest aeroporto Otopeni (OTP)",
      intro: "Atterrate all'aeroporto Henri Coandă di Otopeni e trovate la vostra auto pronta, senza code né sorprese. Il ritiro all'aeroporto è gratuito e il pagamento non richiede carta di credito.",
      perks: airportPerksOtopeni,
      sections: [
        {
          h2: "Ritiro rapido all'aeroporto Henri Coandă",
          body: [
            "Appena atterrati, un nostro incaricato vi accoglie vicino all'area arrivi con le chiavi già pronte per la partenza.",
            "Basta comunicarci l'orario di volo su WhatsApp e organizziamo l'orario di consegna in modo da farvi risparmiare tempo.",
          ],
        },
        {
          h2: "Nessun deposito, nessuna carta di credito",
          body: [
            "A differenza di molte agenzie in aeroporto, non chiediamo un deposito cauzionale né una carta di credito per la prenotazione.",
            "Potete pagare con carta di debito, contanti in EUR o RON oppure con bonifico bancario prima o al momento del ritiro.",
          ],
        },
        {
          h2: "Tutto incluso nel prezzo",
          body: [
            "Ogni noleggio da Otopeni comprende assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato per esplorare la Romania senza limiti.",
            "Con tariffe da 35 EUR al giorno su 28 auto disponibili, trovate facilmente il veicolo giusto per il vostro viaggio.",
          ],
        },
      ],
      faqs: [
        { q: "Il ritiro all'aeroporto di Otopeni ha un costo aggiuntivo?", a: "No, il ritiro all'aeroporto Henri Coandă di Otopeni è completamente gratuito." },
        { q: "Cosa succede se il mio volo è in ritardo?", a: "Nessun problema: monitoriamo l'orario del volo e vi aspettiamo comunque, basta avvisarci su WhatsApp." },
        { q: "Posso pagare in contanti all'arrivo?", a: "Sì, accettiamo contanti in EUR o RON, oltre a carta di debito e bonifico bancario." },
        { q: "Quanto costa il noleggio auto a Otopeni?", a: "I prezzi partono da 35 EUR al giorno, con assicurazione, rovinieta e chilometraggio illimitato inclusi." },
      ],
      keywords: "noleggio auto Bucarest aeroporto, noleggio auto Otopeni, autonoleggio Otopeni OTP",
    },
    "airport-cluj": {
      slug: "noleggio-auto-aeroporto-cluj",
      title: "Noleggio auto aeroporto Cluj (CLJ) | carentals.ro",
      description: "Noleggio auto all'aeroporto di Cluj con consegna organizzata da Bucarest su richiesta. Assicurazione e rovinieta incluse, senza deposito.",
      eyebrow: "Noleggio auto in Transilvania",
      h1: "Noleggio auto aeroporto di Cluj-Napoca (CLJ)",
      intro: "Se atterrate all'aeroporto di Cluj (CLJ), possiamo organizzare la consegna dell'auto direttamente da Bucarest su richiesta, con preventivo personalizzato via WhatsApp. Onestà prima di tutto: la nostra base operativa è a Bucarest.",
      perks: guidePerks,
      sections: [
        {
          h2: "Consegna da Bucarest su richiesta",
          body: [
            "La nostra flotta è basata a Bucarest, quindi per Cluj organizziamo la consegna e il ritiro dell'auto con un preventivo su misura in base alla distanza.",
            "Scrivendoci su WhatsApp con le date e l'orario del volo, vi confermiamo rapidamente disponibilità e costo del trasferimento.",
          ],
        },
        {
          h2: "Un'auto adatta alla Transilvania",
          body: [
            "Per esplorare Cluj e i dintorni collinari della Transilvania consigliamo veicoli affidabili, con buona tenuta di strada e assicurazione completa.",
            "Ogni noleggio include RCA, CASCO, rovinieta e chilometraggio illimitato, indispensabili per itinerari più lunghi fuori Bucarest.",
          ],
        },
        {
          h2: "Prenotazione semplice e flessibile",
          body: [
            "Non è richiesta alcuna carta di credito né un deposito cauzionale, solo un accordo chiaro su modalità di consegna e pagamento.",
            "Il pagamento può avvenire con carta di debito, contanti in EUR o RON, oppure tramite bonifico bancario prima della partenza.",
          ],
        },
      ],
      faqs: [
        { q: "Consegnate le auto direttamente all'aeroporto di Cluj?", a: "Sì, organizziamo la consegna da Bucarest su richiesta, con un preventivo personalizzato in base a data e distanza." },
        { q: "Quanto costa la consegna a Cluj?", a: "Il costo varia in base alla distanza e alla disponibilità: contattateci su WhatsApp per un preventivo rapido." },
        { q: "L'assicurazione copre tutta la Romania?", a: "Sì, RCA e CASCO sono valide su tutto il territorio nazionale, Cluj incluso." },
        { q: "Posso restituire l'auto a Bucarest anziché a Cluj?", a: "Sì, è possibile organizzare un noleggio one-way, previa richiesta e preventivo dedicato." },
      ],
      keywords: "noleggio auto aeroporto Cluj, autonoleggio Cluj Napoca, noleggio auto Transilvania",
    },
    "airport-iasi": {
      slug: "noleggio-auto-aeroporto-iasi",
      title: "Noleggio auto aeroporto Iași (IAS) | carentals.ro",
      description: "Noleggio auto all'aeroporto di Iași con consegna su richiesta da Bucarest. Nessun deposito, assicurazione e rovinieta incluse.",
      eyebrow: "Noleggio auto in Moldavia rumena",
      h1: "Noleggio auto aeroporto di Iași (IAS)",
      intro: "Per chi atterra all'aeroporto di Iași, offriamo la possibilità di ricevere l'auto tramite consegna organizzata da Bucarest, con preventivo dedicato via WhatsApp. La nostra base resta Bucarest, ma il servizio si estende su richiesta.",
      perks: guidePerks,
      sections: [
        {
          h2: "Come funziona la consegna a Iași",
          body: [
            "Contattandoci con anticipo, valutiamo insieme data, orario di volo e punto di consegna per organizzare il trasferimento dell'auto verso Iași.",
            "Il costo dipende dalla distanza da Bucarest e viene comunicato in modo trasparente prima della conferma della prenotazione.",
          ],
        },
        {
          h2: "Auto affidabili per lunghe distanze",
          body: [
            "Per raggiungere e percorrere la regione di Iași consigliamo modelli comodi e con buoni consumi, adatti a percorsi extraurbani.",
            "Ogni veicolo include assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, utili per i lunghi spostamenti verso est.",
          ],
        },
        {
          h2: "Pagamento e assistenza senza pensieri",
          body: [
            "Non chiediamo carta di credito né deposito cauzionale: potete pagare con carta di debito, contanti o bonifico bancario.",
            "Il supporto WhatsApp al +40738792499 resta attivo 24/7 anche durante il viaggio verso o da Iași.",
          ],
        },
      ],
      faqs: [
        { q: "È possibile ritirare l'auto direttamente a Iași?", a: "Sì, tramite consegna organizzata da Bucarest su richiesta, con preventivo personalizzato." },
        { q: "Quanto tempo prima devo prenotare?", a: "Consigliamo di contattarci con almeno qualche giorno di anticipo per organizzare al meglio il trasferimento." },
        { q: "L'assicurazione è valida anche a Iași?", a: "Sì, RCA e CASCO coprono l'intero territorio rumeno, inclusa la regione di Iași." },
        { q: "Posso pagare in RON invece che in EUR?", a: "Sì, accettiamo pagamenti sia in EUR sia in RON, in contanti o tramite bonifico." },
      ],
      keywords: "noleggio auto aeroporto Iasi, autonoleggio Iasi, noleggio auto Moldavia Romania",
    },
    "airport-timisoara": {
      slug: "noleggio-auto-aeroporto-timisoara",
      title: "Noleggio auto aeroporto Timișoara (TSR) | carentals.ro",
      description: "Noleggio auto a Timișoara con consegna su richiesta da Bucarest. Prezzi da 35 EUR/giorno, assicurazione e rovinieta incluse.",
      eyebrow: "Noleggio auto nel Banato",
      h1: "Noleggio auto aeroporto di Timișoara (TSR)",
      intro: "Per l'aeroporto di Timișoara offriamo consegna dell'auto organizzata da Bucarest su richiesta, con preventivo su misura in base alla distanza. Preferiamo essere chiari: la nostra sede operativa resta a Bucarest.",
      perks: guidePerks,
      sections: [
        {
          h2: "Trasferimento dell'auto verso Timișoara",
          body: [
            "Scrivendoci su WhatsApp con le vostre date, valutiamo la fattibilità del trasferimento dell'auto da Bucarest fino a Timișoara.",
            "Vi forniamo un preventivo chiaro che tiene conto della distanza e dell'orario richiesto per la consegna in aeroporto.",
          ],
        },
        {
          h2: "Un'auto adatta al Banato",
          body: [
            "Per muoversi tra Timișoara e i dintorni consigliamo veicoli comodi e affidabili, ideali sia per la città sia per le strade extraurbane.",
            "Assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato sono sempre inclusi, senza costi extra a sorpresa.",
          ],
        },
        {
          h2: "Nessun vincolo di carta di credito",
          body: [
            "Il noleggio non richiede carta di credito né deposito cauzionale: bastano carta di debito, contanti o bonifico bancario.",
            "Restiamo disponibili 24/7 via WhatsApp per qualsiasi necessità durante il vostro soggiorno nel Banato.",
          ],
        },
      ],
      faqs: [
        { q: "Consegnate l'auto direttamente all'aeroporto di Timișoara?", a: "Sì, organizziamo la consegna da Bucarest su richiesta, con preventivo dedicato in base alla distanza." },
        { q: "Qual è il costo minimo del noleggio?", a: "I prezzi partono da 35 EUR al giorno, a cui si aggiunge l'eventuale costo di consegna a Timișoara." },
        { q: "Serve prenotare con largo anticipo?", a: "È consigliabile contattarci qualche giorno prima per organizzare al meglio il trasferimento dell'auto." },
        { q: "Posso restituire l'auto a Bucarest?", a: "Sì, è possibile organizzare un rientro one-way verso Bucarest su richiesta e con preventivo dedicato." },
      ],
      keywords: "noleggio auto aeroporto Timisoara, autonoleggio Timisoara, noleggio auto Banato",
    },
    "airport-sibiu": {
      slug: "noleggio-auto-aeroporto-sibiu",
      title: "Noleggio auto aeroporto Sibiu (SBZ) | carentals.ro",
      description: "Noleggio auto a Sibiu con consegna su richiesta da Bucarest. Assicurazione completa, rovinieta e chilometraggio illimitato inclusi.",
      eyebrow: "Noleggio auto in Transilvania",
      h1: "Noleggio auto aeroporto di Sibiu (SBZ)",
      intro: "Per l'aeroporto di Sibiu, porta d'accesso ideale al Transfăgărășan, organizziamo la consegna dell'auto da Bucarest su richiesta, con preventivo personalizzato. La flotta resta basata a Bucarest, con servizio esteso via WhatsApp.",
      perks: guidePerks,
      sections: [
        {
          h2: "Consegna dell'auto a Sibiu",
          body: [
            "Contattandoci in anticipo su WhatsApp, organizziamo il trasferimento dell'auto da Bucarest fino all'aeroporto di Sibiu.",
            "Il preventivo tiene conto della distanza, della data e dell'orario di consegna richiesto, comunicato con trasparenza prima della conferma.",
          ],
        },
        {
          h2: "Punto di partenza ideale per la Transilvania",
          body: [
            "Da Sibiu potete raggiungere facilmente il Transfăgărășan e i castelli della Transilvania con un'auto affidabile e ben assicurata.",
            "RCA, CASCO, rovinieta e chilometraggio illimitato sono sempre inclusi, per viaggiare senza pensieri lungo le strade di montagna.",
          ],
        },
        {
          h2: "Pagamento flessibile, senza depositi",
          body: [
            "Non è necessaria una carta di credito: il pagamento può avvenire con carta di debito, contanti in EUR o RON, oppure bonifico bancario.",
            "L'assistenza via WhatsApp al +40738792499 è attiva 24/7 durante tutto il vostro itinerario in Transilvania.",
          ],
        },
      ],
      faqs: [
        { q: "È possibile ritirare l'auto direttamente a Sibiu?", a: "Sì, tramite consegna organizzata da Bucarest su richiesta, con preventivo su misura." },
        { q: "Sibiu è un buon punto di partenza per il Transfăgărășan?", a: "Sì, è una delle porte d'accesso più comode a questa strada panoramica." },
        { q: "Che tipo di auto consigliate per la montagna?", a: "Consigliamo veicoli affidabili con buona tenuta di strada; ve li indichiamo su richiesta via WhatsApp." },
        { q: "Devo lasciare un deposito cauzionale?", a: "No, non è richiesto alcun deposito né carta di credito." },
      ],
      keywords: "noleggio auto aeroporto Sibiu, autonoleggio Sibiu, noleggio auto Transfagarasan",
    },
    "city-bucharest": {
      slug: "noleggio-auto-bucarest",
      title: "Noleggio auto Bucarest | carentals.ro da 35 EUR/giorno",
      description: "Noleggio auto a Bucarest con ritiro gratuito in ufficio o in aeroporto. Nessun deposito, assicurazione e rovinieta incluse.",
      eyebrow: "Noleggio auto in città",
      h1: "Noleggio auto a Bucarest, semplice e senza pensieri",
      intro: "Il nostro ufficio si trova in Bulevardul Regina Elisabeta 33, nel cuore di Bucarest, con ritiro gratuito anche all'aeroporto di Otopeni. Muovetevi in città e fuori senza carta di credito né deposito cauzionale.",
      perks,
      sections: [
        {
          h2: "Un ufficio centrale, facile da raggiungere",
          body: [
            "L'ufficio in Bulevardul Regina Elisabeta 33 è comodo sia per chi arriva in centro sia per chi si sposta dall'aeroporto.",
            "Se preferite, possiamo consegnare l'auto in qualsiasi altro indirizzo di Bucarest con un costo fisso di soli 20 EUR.",
          ],
        },
        {
          h2: "Muoversi a Bucarest e dintorni",
          body: [
            "Con 28 auto disponibili trovate facilmente il modello giusto per il traffico cittadino o per una gita fuori porta.",
            "Assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato sono sempre inclusi nel prezzo del noleggio.",
          ],
        },
        {
          h2: "Prenotazione e pagamento senza vincoli",
          body: [
            "Non è richiesta alcuna carta di credito: potete pagare con carta di debito, contanti in EUR o RON, oppure bonifico bancario.",
            "Il nostro team risponde su WhatsApp al +40738792499 24 ore su 24, per prenotazioni, modifiche o assistenza in viaggio.",
          ],
        },
      ],
      faqs: [
        { q: "Dove si trova l'ufficio di noleggio a Bucarest?", a: "L'ufficio è in Bulevardul Regina Elisabeta 33, in pieno centro città." },
        { q: "Posso ritirare l'auto in un altro punto di Bucarest?", a: "Sì, la consegna in qualsiasi altro indirizzo della città costa 20 EUR." },
        { q: "Quali documenti servono per noleggiare?", a: "Bastano documento d'identità e patente di guida valida; non è richiesta carta di credito." },
        { q: "Che orari avete per il ritiro dell'auto?", a: "Il ritiro e la riconsegna sono disponibili 24 ore su 24, tutti i giorni della settimana." },
      ],
      keywords: "noleggio auto Bucarest, autonoleggio Bucarest, affitto auto Bucarest",
    },
    "city-brasov": {
      slug: "noleggio-auto-brasov",
      title: "Noleggio auto Brașov | carentals.ro con consegna disponibile",
      description: "Noleggio auto a Brașov con consegna organizzata da Bucarest. Assicurazione, rovinieta e chilometraggio illimitato inclusi.",
      eyebrow: "Noleggio auto in Transilvania",
      h1: "Noleggio auto a Brașov, con consegna da Bucarest",
      intro: "Brașov è una delle mete più amate della Transilvania, e possiamo far arrivare la vostra auto direttamente qui con consegna organizzata da Bucarest su richiesta. Vi forniamo un preventivo chiaro prima di confermare.",
      perks: guidePerks,
      sections: [
        {
          h2: "Come funziona la consegna a Brașov",
          body: [
            "Scrivendoci su WhatsApp con le vostre date, organizziamo il trasferimento dell'auto dalla nostra sede di Bucarest fino a Brașov.",
            "Il costo del servizio dipende dalla distanza e viene comunicato con trasparenza prima della prenotazione definitiva.",
          ],
        },
        {
          h2: "Esplorare Brașov e la Transilvania",
          body: [
            "Da Brașov si raggiungono facilmente il castello di Bran, Râșnov e le montagne circostanti, ideali per un itinerario di più giorni.",
            "Ogni auto include assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, comodi per spostamenti extraurbani frequenti.",
          ],
        },
        {
          h2: "Nessun deposito, pagamento flessibile",
          body: [
            "Non serve carta di credito: potete pagare con carta di debito, contanti in EUR o RON, oppure bonifico bancario.",
            "Il supporto WhatsApp resta attivo 24/7 anche durante il soggiorno a Brașov, per qualsiasi necessità.",
          ],
        },
      ],
      faqs: [
        { q: "Potete consegnare l'auto direttamente a Brașov?", a: "Sì, organizziamo la consegna da Bucarest su richiesta con preventivo personalizzato." },
        { q: "Quanto costa il trasferimento a Brașov?", a: "Il costo dipende dalla distanza e dalle date; contattateci su WhatsApp per un preventivo rapido." },
        { q: "Posso restituire l'auto a Bucarest?", a: "Sì, è possibile organizzare un rientro one-way su richiesta." },
        { q: "L'assicurazione copre anche le strade di montagna?", a: "Sì, RCA e CASCO coprono l'intero territorio rumeno, incluse le strade verso Brașov." },
      ],
      keywords: "noleggio auto Brasov, autonoleggio Brasov, noleggio auto Transilvania",
    },
    "city-cluj": {
      slug: "noleggio-auto-cluj-napoca",
      title: "Noleggio auto Cluj-Napoca | carentals.ro con consegna",
      description: "Noleggio auto a Cluj-Napoca con consegna organizzata da Bucarest su richiesta. Assicurazione e rovinieta incluse, senza deposito.",
      eyebrow: "Noleggio auto in Transilvania",
      h1: "Noleggio auto a Cluj-Napoca, con consegna su richiesta",
      intro: "Cluj-Napoca è il punto di partenza ideale per scoprire la Transilvania, e possiamo far arrivare l'auto qui tramite consegna organizzata da Bucarest, con preventivo su misura. La nostra flotta resta basata nella capitale.",
      perks: guidePerks,
      sections: [
        {
          h2: "Consegna dell'auto a Cluj-Napoca",
          body: [
            "Con un preavviso ragionevole, organizziamo il trasferimento dell'auto da Bucarest fino a Cluj-Napoca su richiesta.",
            "Il preventivo dipende dalla distanza e dalla data richiesta, e viene comunicato prima di confermare la prenotazione.",
          ],
        },
        {
          h2: "Da Cluj alla scoperta della Transilvania",
          body: [
            "Cluj-Napoca è comoda per raggiungere Turda, la Salina Turda e i borghi tipici della regione con un'auto affidabile.",
            "Ogni noleggio comprende assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, senza costi nascosti.",
          ],
        },
        {
          h2: "Prenotazione semplice, senza vincoli",
          body: [
            "Non è richiesta carta di credito né deposito cauzionale: bastano carta di debito, contanti o bonifico bancario.",
            "Il nostro team risponde su WhatsApp al +40738792499 24 ore su 24, per organizzare al meglio il vostro soggiorno.",
          ],
        },
      ],
      faqs: [
        { q: "È possibile ricevere l'auto direttamente a Cluj-Napoca?", a: "Sì, tramite consegna organizzata da Bucarest su richiesta, con preventivo dedicato." },
        { q: "Quanto tempo prima devo contattarvi?", a: "Consigliamo di scriverci con qualche giorno di anticipo per organizzare il trasferimento." },
        { q: "Posso pagare in RON?", a: "Sì, accettiamo pagamenti sia in EUR sia in RON." },
        { q: "L'assicurazione è valida anche fuori Bucarest?", a: "Sì, RCA e CASCO coprono l'intero territorio rumeno, Cluj incluso." },
      ],
      keywords: "noleggio auto Cluj Napoca, autonoleggio Cluj, noleggio auto Transilvania",
    },
    "city-constanta": {
      slug: "noleggio-auto-costanza",
      title: "Noleggio auto Costanza | carentals.ro con consegna disponibile",
      description: "Noleggio auto a Costanza con consegna organizzata da Bucarest su richiesta. Assicurazione, rovinieta e km illimitati inclusi.",
      eyebrow: "Noleggio auto al Mar Nero",
      h1: "Noleggio auto a Costanza, per la vostra vacanza al Mar Nero",
      intro: "Costanza e le spiagge del Mar Nero sono facilmente raggiungibili con un'auto a noleggio: organizziamo la consegna da Bucarest su richiesta, con preventivo personalizzato via WhatsApp.",
      perks: guidePerks,
      sections: [
        {
          h2: "Consegna dell'auto a Costanza",
          body: [
            "Scrivendoci con le vostre date di viaggio, valutiamo insieme la consegna dell'auto da Bucarest fino a Costanza o in un'altra località costiera.",
            "Il preventivo tiene conto della distanza percorsa e viene comunicato con chiarezza prima della conferma della prenotazione.",
          ],
        },
        {
          h2: "Esplorare la costa del Mar Nero",
          body: [
            "Da Costanza potete raggiungere facilmente Mamaia, Vama Veche e altre località balneari con un'auto comoda e affidabile.",
            "Assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato sono sempre inclusi, ideali per spostamenti frequenti lungo la costa.",
          ],
        },
        {
          h2: "Pagamento comodo, nessun deposito",
          body: [
            "Non è richiesta carta di credito: accettiamo carta di debito, contanti in EUR o RON, oppure bonifico bancario.",
            "L'assistenza WhatsApp al +40738792499 è disponibile 24/7 anche durante la vostra vacanza al mare.",
          ],
        },
      ],
      faqs: [
        { q: "Consegnate l'auto direttamente a Costanza?", a: "Sì, organizziamo la consegna da Bucarest su richiesta con preventivo dedicato." },
        { q: "Qual è la stagione migliore per noleggiare per il Mar Nero?", a: "L'estate è il periodo più richiesto: consigliamo di prenotare con anticipo in alta stagione." },
        { q: "Posso restituire l'auto a Bucarest dopo le vacanze?", a: "Sì, è possibile organizzare un rientro one-way su richiesta e preventivo." },
        { q: "L'assicurazione copre anche le strade costiere?", a: "Sì, RCA e CASCO sono valide su tutto il territorio rumeno, costa inclusa." },
      ],
      keywords: "noleggio auto Costanza, autonoleggio Costanza, noleggio auto Mar Nero Romania",
    },
    cheap: {
      slug: "noleggio-auto-economico-romania",
      title: "Noleggio auto economico Romania | da 35 EUR/giorno",
      description: "Noleggio auto economico in Romania, da 35 EUR al giorno, senza deposito né carta di credito. Assicurazione e rovinieta incluse.",
      eyebrow: "Noleggio auto conveniente",
      h1: "Noleggio auto economico in Romania, senza sorprese",
      intro: "Cercate un noleggio auto economico ma affidabile in Romania? Con carentals.ro le tariffe partono da 35 EUR al giorno, tutto incluso, senza depositi né costi nascosti.",
      perks,
      sections: [
        {
          h2: "Prezzi trasparenti, tutto incluso",
          body: [
            "Ogni tariffa comprende assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, senza costi aggiuntivi a sorpresa.",
            "Con 28 auto in flotta, trovate facilmente il modello più economico adatto alle vostre esigenze di viaggio.",
          ],
        },
        {
          h2: "Come risparmiare sul noleggio",
          body: [
            "Ritirare l'auto direttamente al nostro ufficio di Bucarest o all'aeroporto di Otopeni non comporta alcun costo aggiuntivo.",
            "Prenotare con anticipo via WhatsApp vi permette di bloccare la tariffa più conveniente per le date scelte.",
          ],
        },
        {
          h2: "Nessun deposito, nessuna carta di credito",
          body: [
            "A differenza di molte agenzie, non chiediamo un deposito cauzionale né una carta di credito obbligatoria.",
            "Potete pagare con carta di debito, contanti in EUR o RON, oppure con bonifico bancario, secondo la vostra comodità.",
          ],
        },
      ],
      faqs: [
        { q: "Qual è la tariffa minima per il noleggio auto?", a: "Le tariffe partono da 35 EUR al giorno, con assicurazione e rovinieta incluse." },
        { q: "Ci sono costi nascosti nel prezzo economico?", a: "No, il prezzo indicato include già assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato." },
        { q: "Devo lasciare un deposito cauzionale?", a: "No, non è richiesto alcun deposito né carta di credito." },
        { q: "Come posso ottenere il miglior prezzo?", a: "Contattateci su WhatsApp con le vostre date: vi proponiamo subito la tariffa più conveniente disponibile." },
      ],
      keywords: "noleggio auto economico Romania, autonoleggio low cost Romania, affitto auto economico Bucarest",
    },
    automatic: {
      slug: "noleggio-auto-cambio-automatico-romania",
      title: "Noleggio auto cambio automatico Romania | carentals.ro",
      description: "Noleggio auto con cambio automatico in Romania, da 35 EUR/giorno. Assicurazione completa, rovinieta e km illimitati inclusi.",
      eyebrow: "Guida comoda, senza cambio manuale",
      h1: "Noleggio auto con cambio automatico in Romania",
      intro: "Preferite guidare con il cambio automatico? Nella nostra flotta di 28 auto trovate diversi modelli automatici, perfetti per la città e per i lunghi viaggi in Romania.",
      perks,
      sections: [
        {
          h2: "Comfort di guida in città e in autostrada",
          body: [
            "Il cambio automatico rende più semplice affrontare il traffico di Bucarest e le lunghe percorrenze verso la costa o la montagna.",
            "Ogni auto automatica include comunque assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, come tutti i nostri veicoli.",
          ],
        },
        {
          h2: "Disponibilità e prenotazione",
          body: [
            "Le auto con cambio automatico sono molto richieste: vi consigliamo di prenotare con anticipo scrivendoci su WhatsApp.",
            "Vi confermiamo subito la disponibilità del modello scelto e i dettagli su ritiro gratuito a Bucarest o Otopeni.",
          ],
        },
        {
          h2: "Nessun costo extra per il cambio automatico",
          body: [
            "A differenza di altre agenzie, non applichiamo un sovrapprezzo fisso solo per la scelta del cambio automatico.",
            "Il prezzo finale dipende dal modello scelto, sempre a partire da 35 EUR al giorno, senza depositi richiesti.",
          ],
        },
      ],
      faqs: [
        { q: "Avete auto con cambio automatico disponibili?", a: "Sì, la nostra flotta di 28 auto include diversi modelli con cambio automatico." },
        { q: "Il cambio automatico costa di più?", a: "Il prezzo dipende dal modello scelto, ma non applichiamo un sovrapprezzo fisso solo per il cambio automatico." },
        { q: "Posso ritirare l'auto automatica all'aeroporto?", a: "Sì, il ritiro gratuito è disponibile sia in ufficio a Bucarest sia all'aeroporto di Otopeni." },
        { q: "Conviene prenotare in anticipo?", a: "Sì, i modelli automatici sono molto richiesti: consigliamo di prenotare con anticipo via WhatsApp." },
      ],
      keywords: "noleggio auto cambio automatico Romania, autonoleggio automatico Bucarest, auto automatica Romania",
    },
    "unlimited-km": {
      slug: "noleggio-auto-chilometraggio-illimitato-romania",
      title: "Noleggio auto chilometraggio illimitato Romania",
      description: "Noleggio auto con chilometraggio illimitato in Romania, incluso in ogni tariffa da 35 EUR/giorno. Nessun limite, nessuna sorpresa.",
      eyebrow: "Guidate senza limiti",
      h1: "Noleggio auto con chilometraggio illimitato in Romania",
      intro: "Con carentals.ro il chilometraggio illimitato è sempre incluso, senza costi aggiuntivi né limiti giornalieri. Percorrete tutta la Romania, dalla costa alla montagna, senza preoccuparvi dei chilometri.",
      perks,
      sections: [
        {
          h2: "Nessun limite, nessuna sorpresa in fattura",
          body: [
            "Ogni noleggio, indipendentemente dalla durata, include chilometraggio illimitato senza costi extra al termine del contratto.",
            "Questo vi permette di pianificare itinerari lunghi, come il Transfăgărășan o il giro della Transilvania, senza calcolare i chilometri percorsi.",
          ],
        },
        {
          h2: "Ideale per road trip e itinerari lunghi",
          body: [
            "Il chilometraggio illimitato è particolarmente utile per chi vuole visitare più città o regioni durante lo stesso soggiorno.",
            "Insieme a rovinieta e assicurazione RCA e CASCO incluse, avete tutto il necessario per un viaggio senza pensieri.",
          ],
        },
        {
          h2: "Come prenotare la vostra auto",
          body: [
            "Scriveteci su WhatsApp al +40738792499 indicando le date e l'itinerario previsto, e vi consiglieremo il veicolo più adatto.",
            "Il ritiro è gratuito a Bucarest o all'aeroporto di Otopeni, senza deposito cauzionale né carta di credito richiesta.",
          ],
        },
      ],
      faqs: [
        { q: "Il chilometraggio illimitato è incluso in tutte le tariffe?", a: "Sì, è sempre incluso, senza costi aggiuntivi né limiti giornalieri." },
        { q: "Posso usare l'auto per un lungo road trip?", a: "Sì, il chilometraggio illimitato è ideale per itinerari lunghi in tutta la Romania." },
        { q: "Ci sono penali se percorro molti chilometri?", a: "No, non esistono penali: il chilometraggio è sempre illimitato." },
        { q: "La rovinieta è inclusa insieme al chilometraggio illimitato?", a: "Sì, rovinieta, assicurazione e chilometraggio illimitato sono sempre inclusi nel prezzo." },
      ],
      keywords: "noleggio auto chilometraggio illimitato Romania, autonoleggio km illimitati, noleggio auto senza limiti Romania",
    },
    "one-way": {
      slug: "noleggio-auto-one-way-romania",
      title: "Noleggio auto one-way Romania | carentals.ro",
      description: "Noleggio auto one-way in Romania, con consegna e riconsegna in città diverse su richiesta. Preventivo personalizzato via WhatsApp.",
      eyebrow: "Ritiro e riconsegna in città diverse",
      h1: "Noleggio auto one-way in Romania",
      intro: "Volete ritirare l'auto a Bucarest e restituirla in un'altra città? Il noleggio one-way è possibile su richiesta, con un preventivo personalizzato in base alla distanza e alla destinazione finale.",
      perks: guidePerks,
      sections: [
        {
          h2: "Come funziona il noleggio one-way",
          body: [
            "Contattandoci su WhatsApp con la città di ritiro e quella di riconsegna, valutiamo la fattibilità e vi forniamo un preventivo chiaro.",
            "Il costo dipende dalla distanza tra le due città e dalla disponibilità del veicolo nella data richiesta.",
          ],
        },
        {
          h2: "Ideale per itinerari senza ritorno",
          body: [
            "Il servizio one-way è perfetto per chi vuole visitare Bucarest, la Transilvania o la costa del Mar Nero senza tornare al punto di partenza.",
            "Ogni noleggio include comunque assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato.",
          ],
        },
        {
          h2: "Prenotazione flessibile, senza depositi",
          body: [
            "Non è richiesta carta di credito né deposito cauzionale, anche per i noleggi one-way tra città diverse.",
            "Il pagamento può avvenire con carta di debito, contanti in EUR o RON, oppure bonifico bancario.",
          ],
        },
      ],
      faqs: [
        { q: "Posso restituire l'auto in una città diversa da quella di ritiro?", a: "Sì, il noleggio one-way è possibile su richiesta, con preventivo personalizzato." },
        { q: "Quanto costa il servizio one-way?", a: "Il costo dipende dalla distanza tra le città: contattateci su WhatsApp per un preventivo rapido." },
        { q: "Il one-way è disponibile per tutte le città?", a: "Valutiamo ogni richiesta singolarmente in base a distanza e disponibilità del veicolo." },
        { q: "Serve un deposito extra per il one-way?", a: "No, non è richiesto alcun deposito cauzionale aggiuntivo." },
      ],
      keywords: "noleggio auto one-way Romania, autonoleggio andata sola Romania, noleggio auto ritiro e riconsegna diversa",
    },
    "seven-seater": {
      slug: "noleggio-auto-7-posti-romania",
      title: "Noleggio auto 7 posti Romania | monovolume carentals.ro",
      description: "Noleggio auto a 7 posti e monovolumi in Romania, da 35 EUR/giorno. Assicurazione, rovinieta e chilometraggio illimitato inclusi.",
      eyebrow: "Spazio per tutta la famiglia o il gruppo",
      h1: "Noleggio auto a 7 posti e monovolumi in Romania",
      intro: "Per famiglie numerose o gruppi di amici, offriamo monovolumi e auto a 7 posti comode e spaziose, con tutti i vantaggi del nostro noleggio: nessun deposito, assicurazione completa e chilometraggio illimitato.",
      perks,
      sections: [
        {
          h2: "L'auto giusta per gruppi e famiglie",
          body: [
            "I nostri monovolumi a 7 posti offrono spazio sufficiente per bagagli e passeggeri, ideali per viaggi lunghi in Romania.",
            "Ogni veicolo include assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, senza costi nascosti.",
          ],
        },
        {
          h2: "Disponibilità e prenotazione anticipata",
          body: [
            "Le auto a 7 posti sono molto richieste, soprattutto nei periodi di alta stagione: consigliamo di prenotare con anticipo.",
            "Scrivendoci su WhatsApp con le date del viaggio, vi confermiamo subito la disponibilità del modello più adatto.",
          ],
        },
        {
          h2: "Ritiro gratuito e pagamento flessibile",
          body: [
            "Il ritiro è gratuito presso il nostro ufficio a Bucarest o all'aeroporto di Otopeni, comodo per gruppi in arrivo dall'estero.",
            "Non è richiesta carta di credito: potete pagare con carta di debito, contanti in EUR o RON, oppure bonifico bancario.",
          ],
        },
      ],
      faqs: [
        { q: "Avete auto a 7 posti disponibili?", a: "Sì, la nostra flotta include monovolumi e auto a 7 posti adatti a famiglie e gruppi." },
        { q: "Il prezzo delle auto a 7 posti è più alto?", a: "Il prezzo dipende dal modello scelto, sempre con assicurazione e rovinieta incluse." },
        { q: "Devo prenotare con molto anticipo?", a: "Consigliamo di prenotare in anticipo, soprattutto in alta stagione, per garantire la disponibilità." },
        { q: "Posso ritirare l'auto a 7 posti all'aeroporto di Otopeni?", a: "Sì, il ritiro gratuito è disponibile sia in ufficio a Bucarest sia all'aeroporto di Otopeni." },
      ],
      keywords: "noleggio auto 7 posti Romania, noleggio monovolume Bucarest, autonoleggio famiglia Romania",
    },
    "guide-transfagarasan": {
      slug: "guida-transfagarasan-in-auto",
      title: "Guida al Transfăgărășan in auto | carentals.ro",
      description: "Come percorrere il Transfăgărășan in auto a noleggio: consigli pratici, periodo migliore e auto consigliata per il viaggio.",
      eyebrow: "Itinerario su strada in Romania",
      h1: "Percorrere il Transfăgărășan in auto a noleggio",
      intro: "Il Transfăgărășan è una delle strade panoramiche più famose d'Europa, e noleggiare un'auto affidabile è il modo migliore per percorrerlo in sicurezza. Vi spieghiamo come organizzare al meglio il viaggio.",
      perks: guidePerks,
      sections: [
        {
          h2: "Quando percorrere il Transfăgărășan",
          body: [
            "La strada è generalmente aperta al traffico da fine giugno a fine ottobre, in base alle condizioni della neve in quota.",
            "Vi consigliamo di verificare le condizioni meteo aggiornate prima della partenza e di contattarci su WhatsApp per consigli sul periodo migliore.",
          ],
        },
        {
          h2: "L'auto giusta per la strada di montagna",
          body: [
            "Per affrontare curve e pendenze consigliamo un'auto con buona tenuta di strada, disponibile nella nostra flotta di 28 veicoli.",
            "Ogni noleggio include assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato, fondamentali per un itinerario di più giorni.",
          ],
        },
        {
          h2: "Partenza da Bucarest o Sibiu",
          body: [
            "Potete ritirare l'auto gratuitamente a Bucarest o all'aeroporto di Otopeni e dirigervi verso il Transfăgărășan in poche ore di strada.",
            "In alternativa, organizziamo su richiesta la consegna dell'auto a Sibiu, punto di partenza più vicino alla strada panoramica.",
          ],
        },
      ],
      faqs: [
        { q: "Quando è aperto il Transfăgărășan?", a: "Solitamente da fine giugno a fine ottobre, in base alle condizioni della neve." },
        { q: "Che tipo di auto è consigliata?", a: "Un'auto con buona tenuta di strada è l'ideale; vi consigliamo il modello più adatto su WhatsApp." },
        { q: "Posso partire da Sibiu invece che da Bucarest?", a: "Sì, organizziamo la consegna dell'auto a Sibiu su richiesta, con preventivo dedicato." },
        { q: "L'assicurazione copre anche le strade di montagna?", a: "Sì, RCA e CASCO coprono l'intero territorio rumeno, incluso il Transfăgărășan." },
      ],
      keywords: "Transfagarasan in auto, guida Transfagarasan, noleggio auto Transfagarasan",
    },
    "guide-transylvania": {
      slug: "guida-viaggio-in-transilvania",
      title: "Guida al viaggio in Transilvania in auto | carentals.ro",
      description: "Come organizzare un viaggio in Transilvania in auto a noleggio: castelli, borghi e strade panoramiche da scoprire con la vostra auto.",
      eyebrow: "Itinerario su strada in Romania",
      h1: "Scoprire la Transilvania con un'auto a noleggio",
      intro: "Castelli, borghi medievali e paesaggi collinari fanno della Transilvania una delle mete più affascinanti della Romania. Con un'auto a noleggio potete organizzare l'itinerario secondo i vostri tempi.",
      perks: guidePerks,
      sections: [
        {
          h2: "Le tappe imperdibili della Transilvania",
          body: [
            "Brașov, Sighișoara, il castello di Bran e Sibiu sono tra le tappe più amate, facilmente collegabili in auto in pochi giorni.",
            "Un'auto propria vi permette di scegliere i tempi di visita senza dipendere da orari di autobus o tour organizzati.",
          ],
        },
        {
          h2: "Organizzare il noleggio per il viaggio",
          body: [
            "Potete ritirare l'auto gratuitamente a Bucarest o all'aeroporto di Otopeni prima di dirigervi verso la Transilvania.",
            "Su richiesta organizziamo anche la consegna diretta in città come Brașov, Cluj-Napoca o Sibiu, con preventivo personalizzato.",
          ],
        },
        {
          h2: "Tutto incluso per un viaggio senza pensieri",
          body: [
            "Assicurazione RCA e CASCO, rovinieta e chilometraggio illimitato sono sempre inclusi, ideali per itinerari di più giorni.",
            "Il supporto WhatsApp al +40738792499 resta attivo 24/7 durante tutto il vostro viaggio in Transilvania.",
          ],
        },
      ],
      faqs: [
        { q: "Quali città della Transilvania conviene visitare in auto?", a: "Brașov, Sighișoara, Sibiu e Cluj-Napoca sono tra le mete più consigliate." },
        { q: "Posso ritirare l'auto direttamente in Transilvania?", a: "Sì, organizziamo la consegna in diverse città su richiesta, con preventivo dedicato." },
        { q: "Quanti giorni servono per visitare la Transilvania?", a: "Consigliamo almeno 4-5 giorni per un itinerario completo tra le principali città." },
        { q: "L'assicurazione copre tutto il percorso?", a: "Sì, RCA e CASCO coprono l'intero territorio rumeno, Transilvania inclusa." },
      ],
      keywords: "viaggio Transilvania in auto, itinerario Transilvania, noleggio auto Transilvania",
    },
    "guide-black-sea": {
      slug: "guida-costa-mar-nero-in-auto",
      title: "Guida alla costa del Mar Nero in auto | carentals.ro",
      description: "Come organizzare un viaggio sulla costa del Mar Nero in auto a noleggio: Costanza, Mamaia e le spiagge rumene da scoprire.",
      eyebrow: "Itinerario su strada in Romania",
      h1: "Esplorare la costa del Mar Nero con un'auto a noleggio",
      intro: "Costanza, Mamaia e le spiagge del litorale rumeno sono facilmente raggiungibili in auto da Bucarest. Vi spieghiamo come organizzare al meglio un viaggio verso il Mar Nero.",
      perks: guidePerks,
      sections: [
        {
          h2: "Da Bucarest alla costa in poche ore",
          body: [
            "La distanza tra Bucarest e Costanza si percorre comodamente in un paio d'ore di autostrada, ideale per una gita anche di un solo giorno.",
            "Con un'auto propria potete fermarvi liberamente lungo il percorso e organizzare i tempi secondo le vostre preferenze.",
          ],
        },
        {
          h2: "Le spiagge e le città da non perdere",
          body: [
            "Mamaia, Vama Veche e il centro storico di Costanza offrono un mix di mare, vita notturna e cultura lungo la costa rumena.",
            "Un'auto a noleggio vi permette di spostarvi facilmente tra le diverse località balneari senza dipendere dai trasporti pubblici.",
          ],
        },
        {
          h2: "Organizzare il noleggio per il Mar Nero",
          body: [
            "Potete ritirare l'auto gratuitamente a Bucarest o all'aeroporto di Otopeni prima di partire verso la costa.",
            "Su richiesta organizziamo anche la consegna diretta a Costanza, con preventivo personalizzato in base alla distanza.",
          ],
        },
      ],
      faqs: [
        { q: "Quanto dista Costanza da Bucarest in auto?", a: "Circa due ore di autostrada, un percorso comodo anche per una gita di un giorno." },
        { q: "Posso ritirare l'auto direttamente a Costanza?", a: "Sì, organizziamo la consegna su richiesta, con preventivo dedicato in base alla distanza." },
        { q: "Qual è il periodo migliore per visitare la costa?", a: "L'estate, da giugno a settembre, è il periodo più indicato per il mare in Romania." },
        { q: "L'assicurazione copre anche le strade costiere?", a: "Sì, RCA e CASCO coprono l'intero territorio rumeno, incluso il litorale del Mar Nero." },
      ],
      keywords: "costa Mar Nero in auto, viaggio Costanza in auto, noleggio auto litoral Romania",
    },
    "rules-rovinieta": {
      slug: "regole-rovinieta-romania",
      title: "Rovinieta in Romania: cos'è e come funziona | carentals.ro",
      description: "Cos'è la rovinieta rumena, quando è obbligatoria e perché con carentals.ro è sempre inclusa nel prezzo del noleggio auto.",
      eyebrow: "Regole di guida in Romania",
      h1: "Rovinieta in Romania: tutto quello che c'è da sapere",
      intro: "La rovinieta è il bollo autostradale obbligatorio per circolare sulle strade nazionali rumene. Con carentals.ro non dovete pensarci: è sempre inclusa nel prezzo del noleggio.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Cos'è la rovinieta e a cosa serve",
          body: [
            "La rovinieta è una tassa obbligatoria per l'utilizzo delle strade nazionali rumene, verificata elettronicamente tramite la targa del veicolo.",
            "Senza rovinieta valida si rischiano multe salate, anche per pochi chilometri percorsi su strada nazionale.",
          ],
        },
        {
          h2: "Perché con noi non dovete preoccuparvene",
          body: [
            "Ogni auto della nostra flotta viene noleggiata con la rovinieta già attiva, valida per tutta la durata del contratto.",
            "Questo vale sia per i noleggi a Bucarest sia per quelli con consegna in altre città rumene.",
          ],
        },
        {
          h2: "Altri costi stradali da conoscere",
          body: [
            "Oltre alla rovinieta, alcune strade e ponti particolari, come quello di Cernavodă-Agigea, prevedono un pedaggio separato.",
            "Vi informiamo in anticipo su eventuali pedaggi aggiuntivi durante la consulenza via WhatsApp prima della partenza.",
          ],
        },
      ],
      faqs: [
        { q: "Cos'è esattamente la rovinieta?", a: "È il bollo autostradale obbligatorio per circolare sulle strade nazionali rumene, verificato elettronicamente." },
        { q: "La rovinieta è inclusa nel noleggio?", a: "Sì, è sempre inclusa in ogni tariffa, senza costi aggiuntivi." },
        { q: "Cosa succede se guido senza rovinieta valida?", a: "Si rischiano multe elevate; per questo la includiamo sempre in ogni noleggio." },
        { q: "Ci sono altri pedaggi da pagare in Romania?", a: "Alcuni ponti specifici prevedono un pedaggio separato; vi informiamo in anticipo su eventuali costi extra." },
      ],
      keywords: "rovinieta Romania, bollo autostradale Romania, regole guida Romania",
    },
    "rules-winter-tires": {
      slug: "regole-pneumatici-invernali-romania",
      title: "Pneumatici invernali in Romania: regole | carentals.ro",
      description: "Quando sono obbligatori gli pneumatici invernali in Romania e come carentals.ro garantisce auto sempre equipaggiate correttamente.",
      eyebrow: "Regole di guida in Romania",
      h1: "Pneumatici invernali in Romania: cosa sapere",
      intro: "In Romania, in presenza di neve, ghiaccio o pioggia intensa, è obbligatorio circolare con pneumatici invernali o catene a bordo. Con noi non dovete preoccuparvene: le nostre auto sono sempre correttamente equipaggiate.",
      perks: rulesPerks,
      sections: [
        {
          h2: "Quando sono obbligatori",
          body: [
            "La legge rumena richiede pneumatici invernali, quattro stagioni o catene a bordo quando le strade presentano neve, ghiaccio o pioggia intensa.",
            "Il periodo più critico va generalmente da novembre a marzo, soprattutto sulle strade di montagna come il Transfăgărășan.",
          ],
        },
        {
          h2: "Come carentals.ro garantisce sicurezza",
          body: [
            "Nei mesi invernali equipaggiamo le nostre auto con pneumatici adatti alle condizioni stagionali, senza costi extra per il cliente.",
            "Se pianificate un viaggio in montagna d'inverno, ve lo segnaliamo su WhatsApp per consigliarvi il veicolo più adatto.",
          ],
        },
        {
          h2: "Consigli pratici per l'inverno",
          body: [
            "Vi consigliamo di verificare le previsioni meteo prima di percorsi in montagna e di guidare con prudenza su strade ghiacciate.",
            "L'assicurazione RCA e CASCO inclusa in ogni noleggio vi copre anche durante gli spostamenti nei mesi invernali.",
          ],
        },
      ],
      faqs: [
        { q: "Quando sono obbligatori gli pneumatici invernali in Romania?", a: "In presenza di neve, ghiaccio o pioggia intensa sulla strada, generalmente da novembre a marzo." },
        { q: "Le vostre auto sono già equipaggiate d'inverno?", a: "Sì, nei mesi invernali le nostre auto montano pneumatici adatti alla stagione, senza costi extra." },
        { q: "Posso richiedere catene da neve?", a: "Sì, su richiesta possiamo fornire indicazioni e disponibilità per catene da neve." },
        { q: "L'assicurazione copre incidenti su strada ghiacciata?", a: "Sì, RCA e CASCO coprono i sinistri anche nelle condizioni meteo invernali." },
      ],
      keywords: "pneumatici invernali Romania, regole guida inverno Romania, gomme invernali obbligatorie Romania",
    },
    "rules-speed-cameras": {
      slug: "regole-autovelox-romania",
      title: "Autovelox e limiti di velocità in Romania | carentals.ro",
      description: "Come funzionano autovelox e limiti di velocità in Romania, e come evitare multe durante il vostro noleggio auto con carentals.ro.",
      eyebrow: "Regole di guida in Romania",
      h1: "Autovelox e limiti di velocità in Romania",
      intro: "La Romania applica controlli frequenti tramite autovelox fissi e mobili, con limiti di velocità che variano tra città, strade extraurbane e autostrade. Ecco cosa sapere per guidare senza problemi.",
      perks: rulesPerks,
      sections: [
        {
          h2: "I limiti di velocità principali",
          body: [
            "In città il limite generale è di 50 km/h, sulle strade extraurbane 90 km/h e in autostrada fino a 130 km/h, salvo diversa segnaletica.",
            "I limiti possono variare in prossimità di scuole, ospedali o zone residenziali, spesso segnalati con cartelli specifici.",
          ],
        },
        {
          h2: "Come funzionano i controlli",
          body: [
            "Gli autovelox fissi sono posizionati soprattutto lungo le strade nazionali, mentre la polizia utilizza spesso dispositivi mobili per i controlli.",
            "Le multe per eccesso di velocità in Romania possono essere significative e vengono notificate anche a veicoli a noleggio.",
          ],
        },
        {
          h2: "Come evitare problemi durante il noleggio",
          body: [
            "Vi consigliamo di rispettare sempre la segnaletica locale e di prestare attenzione ai cambi di limite lungo il percorso.",
            "In caso di dubbi sulle regole locali, il nostro team è disponibile su WhatsApp per fornirvi indicazioni pratiche prima della partenza.",
          ],
        },
      ],
      faqs: [
        { q: "Qual è il limite di velocità in città in Romania?", a: "Generalmente 50 km/h, salvo diversa segnaletica locale." },
        { q: "Come vengono rilevate le multe per eccesso di velocità?", a: "Tramite autovelox fissi e dispositivi mobili utilizzati dalla polizia stradale." },
        { q: "Chi paga eventuali multe prese durante il noleggio?", a: "Le multe ricevute durante il periodo di noleggio sono a carico del conducente." },
        { q: "Dove posso avere consigli sulle regole locali?", a: "Il nostro team è disponibile su WhatsApp al +40738792499 per qualsiasi domanda pratica." },
      ],
      keywords: "autovelox Romania, limiti velocità Romania, regole guida Romania",
    },
    "airport-pickup": {
      slug: "ritiro-auto-aeroporto-otopeni-guida",
      title: "Ritiro auto a Otopeni: guida passo passo | carentals.ro",
      description: "Come funziona il ritiro dell'auto a noleggio all'aeroporto di Otopeni: guida passo passo, senza deposito né carta di credito.",
      eyebrow: "Guida pratica al ritiro auto",
      h1: "Come ritirare l'auto all'aeroporto di Otopeni, passo dopo passo",
      intro: "Ritirare l'auto a noleggio all'aeroporto Henri Coandă di Otopeni è semplice e veloce con carentals.ro. Ecco la guida completa, passo dopo passo, per iniziare il vostro viaggio senza stress.",
      perks: airportPerksOtopeni,
      sections: [
        {
          h2: "Prima dell'arrivo: prenotazione e contatto",
          body: [
            "Prenotate scrivendoci su WhatsApp al +40738792499, indicando data e orario di volo, per organizzare il ritiro all'aeroporto di Otopeni.",
            "Vi confermiamo il modello di auto disponibile e i dettagli sul punto di incontro, senza bisogno di carta di credito.",
          ],
        },
        {
          h2: "All'arrivo: dove incontrare il nostro staff",
          body: [
            "Dopo il ritiro bagagli, uscite dall'area arrivi di Otopeni: il nostro incaricato vi aspetterà nel punto concordato in precedenza.",
            "Se il volo subisce ritardi, avvisateci su WhatsApp: monitoriamo gli orari e adattiamo il punto di incontro senza costi aggiuntivi.",
          ],
        },
        {
          h2: "Consegna del veicolo e partenza",
          body: [
            "Verificheremo insieme i documenti e le condizioni dell'auto, quindi potrete scegliere il metodo di pagamento preferito: carta di debito, contanti o bonifico.",
            "Non è richiesto alcun deposito cauzionale: assicurazione, rovinieta e chilometraggio illimitato sono già inclusi, pronti a partire subito.",
          ],
        },
      ],
      faqs: [
        { q: "Dove incontro lo staff all'aeroporto di Otopeni?", a: "Il punto di incontro viene concordato in anticipo su WhatsApp, solitamente vicino all'area arrivi." },
        { q: "Cosa devo portare per il ritiro dell'auto?", a: "Documento d'identità valido e patente di guida sono sufficienti, senza carta di credito obbligatoria." },
        { q: "Cosa succede se il mio volo arriva in ritardo?", a: "Monitoriamo l'orario del volo e adattiamo il punto d'incontro, senza alcun costo aggiuntivo." },
        { q: "Quanto tempo richiede il ritiro dell'auto?", a: "Generalmente pochi minuti, grazie a documenti e pagamento organizzati in anticipo via WhatsApp." },
      ],
      keywords: "ritiro auto Otopeni, guida ritiro noleggio auto aeroporto, noleggio auto Bucarest aeroporto passo passo",
    },
  },
};
